import { PolymorphicAdapter } from "../../../../abstracts/Presenter";
import type { AppsSource } from "../../../../types";
import type { UnknownDestinationModel } from "./interfaces/GeoCodingRepository";
import type { UnknownDestinationViewModelWeb } from "../../../../types";

export class SearchUnknownDestinationPresenter<
  AppSource extends AppsSource,
> extends PolymorphicAdapter<
  UnknownDestinationModel,
  {
    mobile: string[];
    stay: never;
    web: { suggestions: UnknownDestinationViewModelWeb[] };
  },
  AppSource
> {
  protected override displayMobile() {
    return ["1", "2", "3"];
  }
  protected override displayWeb(model: UnknownDestinationModel, query: string) {
    const suggestions = model.map<UnknownDestinationViewModelWeb>(
      (feature) => ({
        coordinates: [
          feature.geometry.coordinates[1],
          feature.geometry.coordinates[0],
        ],
        ...(feature.properties.context.country
          ? {
              country: {
                code:
                  feature.properties.context.country.country_code?.toLowerCase() ??
                  "",
                name: feature.properties.context.country.name,
              },
            }
          : null),
        ...(feature.properties.context.region
          ? {
              region: {
                code:
                  feature.properties.context.region.region_code?.toLowerCase() ??
                  "",
                name: feature.properties.context.region.name,
              },
            }
          : null),
        fullName: feature.properties.full_address,
        matchedQuery: feature.properties.name_preferred
          .split("")
          .map(this.buildMatchedQuery(query)),
      })
    );

    return { suggestions };
  }

  private buildMatchedQuery =
    (query: string) => (char: string, index: number) => ({
      char,
      bold: Boolean(
        query[index] && char.toLowerCase() === query[index].toLowerCase()
      ),
    });
}
